/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SingleLineStringTagSuggestionList } from '../../models/single-line-string-tag-suggestion-list';

export interface StampGetStampTagSuggestionList$Params {

/**
 * GUID of the tag definition
 */
  tagDefinitionId?: string;

/**
 * GUID of the vault
 */
  vaultId?: string;

/**
 * Search text
 */
  searchText?: string;

/**
 * Requested offset in found suggestions
 */
  offset?: number;

/**
 * Requested suggestion item count. Value must be less than or equal to 255
 */
  count?: number;
}

export function stampGetStampTagSuggestionList(http: HttpClient, rootUrl: string, params?: StampGetStampTagSuggestionList$Params, context?: HttpContext): Observable<StrictHttpResponse<SingleLineStringTagSuggestionList>> {
  const rb = new RequestBuilder(rootUrl, stampGetStampTagSuggestionList.PATH, 'get');
  if (params) {
    rb.query('tagDefinitionId', params.tagDefinitionId, {});
    rb.query('vaultId', params.vaultId, {});
    rb.query('searchText', params.searchText, {});
    rb.query('offset', params.offset, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SingleLineStringTagSuggestionList>;
    })
  );
}

stampGetStampTagSuggestionList.PATH = '/stamp/single-line-string/suggestion/list';
